import { FC, ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AiFillHome } from 'react-icons/ai';
import { FiChevronRight } from 'react-icons/fi';

export interface NavPage {
  name: ReactNode;
  to: string;
}

interface BreadcrumbProps {
  page: NavPage;
}

interface BreadcrumbsProps {
  pages: NavPage[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ page }) => {
  return (
    <li key={page.to}>
      <div className="flex items-center">
        <FiChevronRight className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
        <NavLink
          to={page.to}
          className={
            'flex border items-center border-transparent py-2 px-3 pr-3 text-sm font-medium hover:font-bold'
          }
        >
          {page.name}
        </NavLink>
      </div>
    </li>
  );
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ pages }) => {
  return (
    <nav className="flex mb-px print:hidden text-primary-800" aria-label="Breadcrumb">
      <ol className="flex items-center">
        <li>
          <div className="mr-3">
            <Link to="/" className="hover:font-bold">
              <AiFillHome className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
            </Link>
          </div>
        </li>
        {pages.map(page => (
          <Breadcrumb page={page} key={page.to} />
        ))}
      </ol>
    </nav>
  );
};
